import { InjectionToken } from '@angular/core';
import { ChatComponent } from '../_shared/chat-types';

export const WASHER_DRYER = new InjectionToken<ChatComponent>('WASHER_DRYER');
